module.exports = __webpack_public_path__ + "static/media/course-minimum-units.0099e448.svg";